import { Checkbox, Form, Select, Space, Typography } from "antd";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import SpaceWrapper from "../../components/widgets/space-wrapper/SpaceWrapper";
import { CustomButton } from "../../components/widgets/custom-button/CustomButton";
import { useAxiosPrivate } from "../../hooks/useAxiosPrivate";
import { useSessionStore } from "../../store/session-store";
import { useCustomToolStore } from "../../store/custom-tool-store";
import { useAlertStore } from "../../store/alert-store";
import { useExceptionHandler } from "../../hooks/useExceptionHandler";

function ChallengeManager({ handleUpdateTool }) {
  const [selectedLlm, setSelectedLlm] = useState("");
  const [enableChallenge, setEnableChallenge] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [llmItems, setLlmItems] = useState([]);
  const { sessionDetails } = useSessionStore();
  const { details, updateCustomTool, isPublicSource } = useCustomToolStore();
  const axiosPrivate = useAxiosPrivate();
  const { setAlertDetails } = useAlertStore();
  const handleException = useExceptionHandler();
  const { id } = useParams();

  useEffect(() => {
    setEnableChallenge(details?.enable_challenge || false);
    setLlmProfilesDropdown();
  }, []);

  useEffect(() => {
    const llmProfile = details?.challenge_llm;
    if (
      llmItems?.length &&
      llmItems.find((item) => item?.value === llmProfile)
    ) {
      setSelectedLlm(llmProfile);
    }
  }, [llmItems]);

  const setLlmProfilesDropdown = () => {
    let url = `/api/v1/unstract/${sessionDetails?.orgId}/adapter`;
    if (isPublicSource) {
      url = `/public/share/adapter-metadata/?id=${id}`;
    }
    const requestOptions = {
      method: "GET",
      url,
    };

    axiosPrivate(requestOptions)
      .then((res) => {
        const data = res?.data;

        data.forEach((item) => {
          if (item?.adapter_type === "LLM") {
            setLlmItems((prev) => {
              const newItems = [...prev];
              newItems.push({
                value: item?.id,
                label: item?.adapter_name,
              });
              return newItems;
            });
          }
        });
      })
      .catch((err) => {
        setAlertDetails(
          handleException(
            err,
            "Failed to get the dropdown list for LLM Adapters"
          )
        );
      });
  };

  const handleSubmit = () => {
    const body = {
      challenge_llm: selectedLlm,
      enable_challenge: enableChallenge,
    };
    setIsLoading(true);
    handleUpdateTool(body)
      .then((res) => {
        const data = res?.data;
        const updatedDetails = { ...details };
        updatedDetails["challenge_llm"] = data?.challenge_llm;
        updatedDetails["enable_challenge"] = data?.enable_challenge;
        updateCustomTool({ details: updatedDetails });

        setAlertDetails({
          type: "success",
          content: "Saved challenge settings successfully",
        });
      })
      .catch((err) => {
        setAlertDetails(handleException(err, "Failed to update"));
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <SpaceWrapper>
      <div className="settings-body-pad-top">
        <Typography.Text strong className="pre-post-amble-title">
          LLMChallenge Settings
        </Typography.Text>
      </div>
      <Form layout="vertical" onFinish={handleSubmit}>
        <Form.Item label="Challenger LLM">
          <Select
            options={llmItems}
            value={selectedLlm}
            onChange={(value) => setSelectedLlm(value)}
            disabled={isPublicSource}
          />
        </Form.Item>
        <Form.Item>
          <Space>
            <Checkbox
              checked={enableChallenge}
              onChange={(e) => setEnableChallenge(e.target.checked)}
              disabled={isPublicSource}
            />
            <Typography.Text>Enable LLMChallenge</Typography.Text>
          </Space>
        </Form.Item>
        <Form.Item className="display-flex-right">
          <CustomButton
            type="primary"
            htmlType="submit"
            loading={isLoading}
            disabled={isPublicSource}
          >
            Save
          </CustomButton>
        </Form.Item>
      </Form>
    </SpaceWrapper>
  );
}

ChallengeManager.propTypes = {
  handleUpdateTool: PropTypes.func.isRequired,
};

export { ChallengeManager };
